/**
 * Fabric variant price fix
 * Updates price on variant button click
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    this.priceContainer = this.querySelector('[ref="priceContainer"]');
    if (!this.priceContainer) return;

    this.productJson = document.querySelector('script[type="application/json"][data-product-json]');
    if (!this.productJson) return;

    try {
      this.productData = JSON.parse(this.productJson.textContent);
    } catch {
      return;
    }

    this.bindVariantButtons();
  }

  bindVariantButtons() {
    const variantButtons = document.querySelectorAll('[data-variant-id]');

    variantButtons.forEach(button => {
      button.addEventListener('click', () => {
        const variantId = button.getAttribute('data-variant-id');
        this.updatePriceByVariantId(variantId);
      });
    });
  }

  updatePriceByVariantId(variantId) {
    if (!this.productData?.variants) return;

    const variant = this.productData.variants.find(v => String(v.id) === String(variantId));
    if (!variant || !variant.price) return;

    const formattedPrice =
      (variant.price / 100).toLocaleString('cs-CZ') + ' Kč';

    this.priceContainer.textContent = formattedPrice;
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
